"use strict";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

let imagesLoaded = require('imagesloaded');
import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade} from 'swiper/modules';

gsap.registerPlugin(ScrollTrigger);

let stoerer = null;

//stoerer
function hideStoerer() {
    Cookies.set('stoerer', 'no', { expires: 14 })
    stoerer.classList.remove('show')
}

document.addEventListener('DOMContentLoaded', function () {
    console.log('Init Scripts');

    // menu
    const menuBtn = document.getElementById('menu-burger');
    const b1 = document.querySelector('#menu-burger .b1');
    const b2 = document.querySelector('#menu-burger .b2');
    const overlay = document.getElementById('menu-overlay');
    const menuItems = gsap.utils.toArray('.menuItems a');
    const sMenuBtn = gsap.utils.toArray('.menuItems .has-submenu-arrow');
    const sMenuBtn2 = gsap.utils.toArray('.menuItems .has-submenu');
    let nav = document.querySelector(".navbar");
    let scrollTop = document.getElementById("scroll-top");
    let mm = gsap.matchMedia();
    let menuOpen = false;
    let navTl = null;
    const breakPoint = 1199;
    let isMobileG = false;

    // stoerer
    stoerer = document.getElementById('stoerer');

    if (stoerer) {
        let btnC = stoerer.querySelector('.closeX')
        btnC.addEventListener('click', function (evt) {
            hideStoerer()
        })
    }

    //stoerer
    if (document.querySelectorAll("#stoerer").length > 0) {
        let cookie = Cookies.get('stoerer')
        if(cookie === 'no'){
            stoerer.classList.remove('show')
        }else{
            stoerer.classList.add('show')
        }
    }

    mm.add({
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint}px)`,
    }, (context) => {
        let {isDesktop, isMobile} = context.conditions;
        // hide overlay
        gsap.set(overlay, {
            marginTop: isMobile ? "-100vh" : 0
        })

        isMobileG = !!isMobile;
        // set menuItems
        gsap.set(menuItems, {
            opacity: isMobile ? 0 : 1
        })

        // overlay timeline
        navTl = gsap.timeline({
            defaults: {
                ease: 'power4.inOut',
                repeatRefresh: true,
            }
        });

        navTl
            .to(b1, {
                y: '-=5',
                duration: 0.2
            })
            .to(b2, {
                y: '+=5',
                duration: 0.2
            }, "-=0.2")
            .to(b1, {
                rotation: 45,
                transformOrigin: '50% 50%',
                duration: 0.3
            })
            .to(b2, {
                rotation: -45,
                transformOrigin: '50% 50%',
                duration: 0.3
            }, "-=0.3")
            .to(overlay, {
                marginTop: 0,
                duration: 0.5
            }, "-=0.5")
            .to(menuItems, {
                opacity: 1,
                stagger: 0.05,
                duration: 0.5
            }, "-=0.2")
        navTl.pause();
    })

    // toggle menu
    menuBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (!menuOpen) {
            navTl.play();
            menuOpen = true;
        } else {
            navTl.reverse();
            menuOpen = false;
        }
    })

    // submenu toggle for mobile
    const navItemsWithSubmenu = document.querySelectorAll('.nav-item:has(.subItems)');
    navItemsWithSubmenu.forEach(item => {
        const navLink = item.querySelector('.nav-link');
        navLink.addEventListener('click', (evt) => {
            if (isMobileG) {
                evt.preventDefault();
                item.classList.toggle('submenu-open');
            }
        });
    });

    // open all external links in new tab
    const allLinks = document.querySelectorAll('a[href^="http://"], a[href^="https://"]');
    allLinks.forEach(link => {
        const currentDomain = window.location.hostname;
        const linkDomain = new URL(link.href).hostname;
        if (linkDomain !== currentDomain) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        }
    });

    imagesLoaded(document.querySelector("main"), function (instance) {
        const stl = gsap.timeline();
        stl.to('.loader', {opacity: 0, duration: 0.3}, '-=0');
        stl.to('.navbar', {opacity: 1, duration: 0.6}, '-=0');
        stl.to('main', {opacity: 1, duration: 0.6}, '-=0.3');
        stl.to('footer', {opacity: 1, duration: 0.6}, '-=0');

        if (document.querySelector(".hero")) {
        }

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".hero",
                start: "top top",
                end: "bottom top",
                scrub: true
            }
        });
        if (!isMobileG) {
            gsap.utils.toArray(".parallax").forEach(layer => {
                const depth = layer.dataset.depth;
                const movement = -(layer.offsetHeight * depth);

                tl.to(layer, {y: movement, ease: "none"}, 0);

            });
        }

        // swiper
        const swiper = new Swiper('.impressionSwiper', {
            modules: [Navigation, Pagination, EffectFade],
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            effect: 'fade',
            // To avoid overlapping issues, especially with autoplay
            fadeEffect: {
                crossFade: true,
            },
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
        });

        // accordion
        const accordionGroups = document.querySelectorAll('.accordion-group');
        accordionGroups.forEach(group => {
            group.addEventListener('click', function () {
                this.classList.toggle('expanded');
            });
        });
    })
});